export default __webpack_public_path__ + "static/media/java1.e68396d2.jpg";